import { render, staticRenderFns } from "./addOrEditVip.vue?vue&type=template&id=99d16508&scoped=true"
import script from "./addOrEditVip.vue?vue&type=script&lang=js"
export * from "./addOrEditVip.vue?vue&type=script&lang=js"
import style0 from "./addOrEditVip.vue?vue&type=style&index=0&id=99d16508&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d16508",
  null
  
)

export default component.exports